<template>
    <li class="relative">
        <button
            @click.prevent="toggleAddMenu"
            :aria-expanded="isAddOpen"
            class="bg-v2-white border border-v2-white text-v2-gray-20 flex gap-3 items-center w-full p-3 rounded hover:border-v2-gray-70 dark:bg-v2-gray-65 dark:border-v2-gray-10 dark:text-v2-gray-130 hover:dark:border-v2-gray-90 hover:dark:text-v2-white"
        >
            <BaseSvg name="Add" class="fill-v2-gray-70 size-[18px] dark:fill-v2-gray-90"/>
            <span class="flex gap-1 grow justify-between">
            <span>Add to...</span>
                <BaseSvg
                    :name="isAddOpen ? 'ExpandLess' : 'ExpandMore'"
                    class="fill-v2-gray-70 size-[18.5px] dark:fill-v2-gray-90"
                />
            </span>
        </button>
        <form v-if="isAddOpen" class="mt-1 p-3 bg-v2-white rounded-b dark:bg-v2-gray-65">
            <button
                v-if="pin.type === 'item'"
                :disabled="isLoading"
                class="mb-4 btn-app-sm-white-on-black disabled:opacity-50 disabled:pointer-events-none flex gap-1 items-center justify-center font-medium px-3 py-1.5 w-full"
                @click.prevent="addItemToCart(pin.pinnable_id)"
            >
                <LoadingCircle v-if="isLoading" class="w-4 h-4 mr-0.5" />
                <BaseSvg v-else name="ShoppingCartThick" class="size-[18px] fill-primary"/>
                {{ $t('Add to cart') }}
            </button>
            <div class="h-40 overflow-shadows-vertical overscroll-auto">
                <div>
                    <h3 class="text-[12px] uppercase text-v2-gray-80">Trays</h3>
                    <ul class="space-y-3 mt-2">
                        <li v-for="tray in drawer.trays" :key="tray.id">
                            <label class="flex gap-3 items-center leading-none">
                                <input
                                    type="checkbox"
                                    :checked="pin.trays.includes(tray.name)"
                                    @change="() => onTrayToggle(tray)"
                                    class="peer sr-only"
                                />
                                <BaseSvg
                                    name="Check"
                                    class="border border-v2-gray-90 fill-none p-px rounded-full size-4 peer-checked:border-v2-green peer-checked:fill-v2-green dark:border-v2-gray-70"
                                />
                                {{ tray.name }} ({{ tray.pin_count }})
                            </label>
                        </li>
                    </ul>
                </div>
                <div>
                    <h3 class="mt-4 text-[12px] text-v2-gray-80 uppercase">Projects</h3>
                    <LoadingCircle v-if="isLoadingProjects" />
                    <ul v-else-if="projects?.length" class="mt-2 space-y-3 dark:text-v2-gray-130">
                        <li v-for="project in projects" :key="project.id">
                            <label class="flex font-medium gap-3 items-center leading-none">
                                <input
                                    type="checkbox"
                                    :value="project.id"
                                    class="peer sr-only"
                                    @change="addItemToProject(project.uuid, pin.slug)"
                                />
                                <BaseSvg
                                    name="Check"
                                    aria-hidden="true"
                                    class="border border-v2-gray-90 fill-none p-px rounded-full shrink-0 size-4 peer-checked:border-v2-green peer-checked:fill-v2-green dark:bg-v2-gray-40 dark:border-v2-gray-70"
                                />
                                <span class="truncate">{{ project.label }}</span>
                            </label>
                        </li>
                    </ul>
                    <div v-else class="type-tertiary">No Projects Yet</div>
                </div>
            </div>
        </form>
    </li>
</template>
<script setup>

import {onMounted, ref} from "vue";
import {usePinsDrawer, useProjects} from "@/Composables";
import {LoadingCircle} from "@/Components";

const props = defineProps(['pin']);
const isAddOpen = ref(false);

function toggleAddMenu() {
    isAddOpen.value = !isAddOpen.value;
}

const { addItemToCart, isLoading, drawer, handlePinToTray, addItemToProject } = usePinsDrawer();
const { isLoadingProjects, loadProjects, projects } = useProjects();

const selectedTrays = ref(new Set(
    drawer.trays
        ?.filter(tray => tray.is_pinned)
        ?.map(tray => tray.name)
))

onMounted(() => {
    loadProjects();
})

async function onTrayToggle(tray) {
    const name = tray.name
    const adding = !selectedTrays.value.has(name)

    try {
        const response = await handlePinToTray(props.pin.type, props.pin.pinnable_id, name)
        const current = response.data.pin.trays.map((tray) => tray.name)

        selectedTrays.value = new Set(current)
    } catch (e) {
        if (adding) {
            selectedTrays.value.delete(name)
        } else {
            selectedTrays.value.add(name)
        }
        console.error('togglePinToTray failed', e)
    }
}
</script>
